import { createFileRoute } from "@tanstack/react-router";
import { EsRevisionSpokePage } from "@/components/site/EsRevisionSpokePage";
import { ES_REVISION_HOW_PERFORMED, ES_REVISION_SPOKE_BY_PAGE } from "@/lib/es-revision-spokes";
import { esHead, esWebPageSchema, SITE } from "@/lib/es-pages";
import { PHYSICIAN_REF } from "@/lib/medical-schema";

const PAGE = "revisionsTore" as const;
const url = `${SITE}/es/cirugia-de-revision/tore`;

export const Route = createFileRoute("/es/cirugia-de-revision_/tore")({
  head: () => {
    const head = esHead(PAGE);
    const spoke = ES_REVISION_SPOKE_BY_PAGE.revisionsTore;
    return {
      ...head,
      scripts: import.meta.env.SSR ? [{
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              ...esWebPageSchema(PAGE),
              "@type": "MedicalWebPage",
              name: spoke.h1,
              reviewedBy: PHYSICIAN_REF,
              mainEntity: { "@id": `${url}#procedure` },
            },
            {
              "@type": "MedicalProcedure",
              "@id": `${url}#procedure`,
              mainEntityOfPage: { "@id": `${url}#webpage` },
              procedureType: "https://schema.org/TherapeuticProcedure",
              name: spoke.procedureName,
              alternateName: spoke.procedureAlternateNames,
              description: spoke.procedureDescription,
              url,
                  howPerformed: ES_REVISION_HOW_PERFORMED[PAGE],
            },
            {
              "@type": "FAQPage",
              "@id": `${url}#faq`,
              inLanguage: "es-US",
              mainEntity: spoke.faqs.map((faq, i) => ({
                "@type": "Question",
                "@id": `${url}#faq-${i + 1}`,
                name: faq.q,
                acceptedAnswer: { "@type": "Answer", text: faq.a },
              })),
            },
          ],
        }),
      }] : [],
    };
  },
  component: EsToreRevision,
});

function EsToreRevision() {
  return <EsRevisionSpokePage spoke={ES_REVISION_SPOKE_BY_PAGE.revisionsTore} />;
}